import $ from 'jquery';

// Customised episerver forms file upload
// Copies file name from input into span
var _initFileUplaod = function () {

    $('.FormFileUpload__Input').change(function (e) {

        var insertLabelLocation = $(this).next(".Form__Element__Caption").find("span");
        var fileName = e.target.value.split('\\').pop();
        $(this).next('label').find('span').text(fileName);

        $('<button class="js-cancel-file-upload cancel-file-upload">&#x2715</button>').insertBefore(insertLabelLocation);

        _cancelFileUpload();

    });

};

var _cancelFileUpload = function () {

    $('.js-cancel-file-upload').click(function (e) {
        e.preventDefault();

        var button = $(this);
        var $input = button.parent().prev('.FormFileUpload__Input');

        button.remove(); // remove close icon

        $input.val(''); // set value to empty
        $input.next('label').find('span').text(''); // remove filename within input
        $input[0].dispatchEvent(new Event("removed")); // needed for vue forms. can't use changed or i re-trigger _initFileUplaod
    });

};

_initFileUplaod();